module.exports = "./img/9aaf00ab987f561b5e7db6cdf07b9261.jpg";